import { timeInterval as n } from "./interval.js";
const i = n(() => {
}, (r, e) => {
  r.setTime(+r + e);
}, (r, e) => e - r);
i.every = (r) => (r = Math.floor(r), !isFinite(r) || !(r > 0) ? null : r > 1 ? n((e) => {
  e.setTime(Math.floor(e / r) * r);
}, (e, t) => {
  e.setTime(+e + t * r);
}, (e, t) => (t - e) / r) : i);
i.range;
export {
  i as millisecond
};
